import { useEffect, useState } from 'react';

/** True once `active` has stayed true for `delay` ms; false again as soon as it stops. */
export function useSlowFlag(active, delay = 1500) {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    if (!active) {
      setSlow(false);
      return undefined;
    }
    const t = setTimeout(() => setSlow(true), delay);
    return () => clearTimeout(t);
  }, [active, delay]);
  return slow;
}
